export default "__VITE_ASSET__usZ49cBk__"